// 고객 후기(현장 하나에 한 편) — 표 모양은 `0044` 의 customer_review 와 같다. 별점은 두지 않는다.

import type { OrgScopedRow } from "../common/types";

// `0044` customer_review_body_len 과 같은 자(앞뒤 공백을 뺀 글자 수).
export const MAX_REVIEW_BODY = 1000;

// `0044` customer_review_author_label_len 과 같은 자.
export const MAX_AUTHOR_LABEL = 20;

export interface CustomerReview extends OrgScopedRow {
  project_id: string;
  author_label: string;
  body: string;
  consent_public: boolean;
  consented_at: string | null;
  hidden: boolean;
}

// 공개 링크(admin)가 읽는 열만 — 현장·동의 시각은 나가지 않는다.
export type PublicReviewRow = Pick<CustomerReview, "id" | "author_label" | "body" | "consent_public" | "hidden">;

// 고객이 링크에서 보내는 것 — 표기 스냅숏과 동의 시각은 저장소가 규칙(rules)으로 만든다.
export interface ReviewInput {
  id: string;
  body: string;
  anonymous: boolean;
  consent_public: boolean;
}

// 고객 링크 화면에 넘기는 것 — 이름 표기 미리보기는 저장과 같은 원천(계약 client_name)·같은 함수로 만든다.
export interface ReviewShare {
  review: CustomerReview | null;
  named_label: string;
}
